import { getAge } from './getAge';
import { calculateAgeAtExamDate } from './getAgeAtExamDate';

type ResolvePatientAgeParams = {
    dateOfBirth?: string;
    examDate?: string;
    fallbackAge?: number | string;
};

const isValidBirthDate = (value?: string) => {
    if (!value) return false;

    const birthDate = new Date(value);

    return !Number.isNaN(birthDate.getTime()) && birthDate <= new Date();
};

const normalizeFallbackAge = (value?: number | string) => {
    if (typeof value === 'number') {
        return Number.isFinite(value) ? value : undefined;
    }

    if (typeof value !== 'string') return undefined;

    const normalizedValue = value.trim();

    if (!normalizedValue) return undefined;

    const parsedValue = Number(normalizedValue);

    return Number.isFinite(parsedValue) ? parsedValue : undefined;
};

export const resolvePatientAge = ({
    dateOfBirth,
    examDate,
    fallbackAge,
}: ResolvePatientAgeParams) => {
    const hasValidBirthDate = isValidBirthDate(dateOfBirth);
    const validDateOfBirth = hasValidBirthDate ? dateOfBirth : undefined;

    if (validDateOfBirth && examDate) {
        const exactAge = calculateAgeAtExamDate(validDateOfBirth, examDate)?.years;

        if (typeof exactAge === 'number' && Number.isFinite(exactAge) && exactAge >= 0) {
            return exactAge;
        }
    }

    if (validDateOfBirth) {
        return getAge(validDateOfBirth);
    }

    return normalizeFallbackAge(fallbackAge);
};
